import React, { useState } from "react";
import RiskTriggerTable from "./components/RiskTriggerTable";
import AvailableDatamarts from "./components/AvailableDatamarts";
import GenerateActionCardModal from "./components/GenerateActionCardModal";
import FRMNav from "./components/FRMNav";

// const RiskTriggerCardSetup = () => {
//   const [search, setSearch] = useState("");
// const [modalOpen, setModalOpen] = useState(false);
// const [refreshKey, setRefreshKey] = useState(0); // 👈 add this

// const handleCreate = (formData) => {
//   setRefreshKey(prev => prev + 1); // 👈 bump after submit
// };

// // Pass refreshKey to table:
// <RiskTriggerTable search={search} refreshKey={refreshKey} />

//   document.title = "Risk Trigger Card Setup | FRM";

//   return (
//     <div style={{ display: "flex", gap: 14, padding: 16, background: "#f5f6f8", minHeight: "calc(100vh - 96px)" }}>
//       {/* Left — main table area */}
//       <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 12 }}>

//         {/* Toolbar */}
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
//           <div style={{ position: "relative" }}>
//             <svg
//               width="14" height="14" viewBox="0 0 24 24" fill="none"
//               stroke="#aab0be" strokeWidth="2"
//               style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }}
//             >
//               <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
//             </svg>
//             <input
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//               placeholder="Search alert tags..."
//               style={{
//                 paddingLeft: 32, paddingRight: 12, height: 34, width: 220,
//                 border: "0.5px solid #e2e4e8", borderRadius: 6,
//                 fontSize: 12, color: "#1a1e2e", background: "#fff", outline: "none",
//               }}
//             />
//           </div>
//          <button
//   style={{
//     background: "#1a9e78", color: "#fff", border: "none",
//     borderRadius: 6, padding: "7px 16px", fontSize: 12,
//     fontWeight: 500, cursor: "pointer",
//     display: "flex", alignItems: "center", gap: 6,
//   }}
//   onClick={() => setModalOpen(true)}  
//   >
//   <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
//     stroke="currentColor" strokeWidth="2.5">
//     <line x1="12" y1="5" x2="12" y2="19"/>
//     <line x1="5" y1="12" x2="19" y2="12"/>
//   </svg>
//   Generate Risk Trigger Card
// </button>
//         </div>
//  <GenerateActionCardModal
//   isOpen={modalOpen}
//   onClose={() => setModalOpen(false)}
//   onSubmit={handleCreate}
// />
//         {/* Table */}
//         <RiskTriggerTable search={search} />
//       </div>

//       {/* Right — datamarts panel */}
//       <div style={{ width: 260, flexShrink: 0 }}>
//         <AvailableDatamarts />
//       </div>
     
//     </div>
//   );
// };



const RiskTriggerCardSetup = ({ selectedMachine })  => {
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
 
  const handleCreate = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <>
      {/* Pass down to FRMNav — wherever you render it */}
      {/* <FRMNav
        // ...your existing props
        selectedMachine={selectedMachine}
        onMachineChange={handleMachineChange}
      /> */}

      <div style={{ display: "flex", gap: 14, padding: 16, background: "#f5f6f8", minHeight: "calc(100vh - 96px)" }}>
        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 12 }}>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
            {/* search input ... */}
            <button onClick={() => setModalOpen(true)} style={{ background: "#1a9e78", color: "#fff", border: "none", borderRadius: 6, padding: "7px 16px", fontSize: 12, fontWeight: 500, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
              Generate Risk Trigger Card
            </button>
          </div>

          <GenerateActionCardModal
            isOpen={modalOpen}
            onClose={() => setModalOpen(false)}
            onSubmit={handleCreate}
          />

          {/* 👇 pass both */}
          <RiskTriggerTable
            search={search}
            refreshKey={refreshKey}
            selectedMachine={selectedMachine}
          />
        </div>

        <div style={{ width: 260, flexShrink: 0 }}>
          <AvailableDatamarts />
        </div>
      </div>
    </>
  );
};
export default RiskTriggerCardSetup;